import _Vue, { PluginFunction, PluginObject } from 'vue';

import Workflow from './Workflow.vue';

export function WorkflowPlugin(Vue: typeof _Vue, options?: {}) {
  Vue.component('workflow', Workflow);
}
